import { createSelector } from "@ngrx/store";

import { RegistrationFeatureState } from "../../state";

import { AddressState } from "./address.model";

export namespace AddressSelector {
	export const getState = (state: RegistrationFeatureState) => state.registrationFeature.address;

	export const isBusy = createSelector(getState, (state: AddressState) => state.isBusy);

	export const success = createSelector(getState, (state: AddressState) => state.success);
}
